export * from './simple-layout.component';



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/containers/simple-layout/index.ts